import { render, staticRenderFns } from "./TablesPaginationMenu.vue?vue&type=template&id=130269d8&scoped=true&"
import script from "./TablesPaginationMenu.vue?vue&type=script&lang=js&"
export * from "./TablesPaginationMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130269d8",
  null
  
)

export default component.exports